import { useMutation, useQueryClient } from '@tanstack/react-query';
import { completeTaskContract, type CompleteTaskResponse } from '@bliks-io/contracts';
import { apiClient } from '../client';
import { taskKeys } from '../query-keys';

/**
 * Marks one of the caller's Aufgaben done. Invalidates the whole `tasks`
 * prefix so the list and both sidebar badges drop the row together.
 */
export function useCompleteTask() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ taskId }: { taskId: string }): Promise<CompleteTaskResponse> => {
      const path = completeTaskContract.path.replace(':id', taskId);
      const { data } = await apiClient.post<CompleteTaskResponse>(path, undefined);
      return data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: taskKeys.all });
    }
  });
}
